import React from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Select,
  Form,
  Card,
  Checkbox,
  Divider,
} from 'semantic-ui-react';

import FacebookAdsManager from '../facebook-ads-manager';

import { DYZIO_CURRENCIES } from '../../utils/helpers/currencies';
import ShopifyConnectionSettings from '../shopify-connection-settings';

const OrganisationSettings = ({ organisation, onChange, fetchOrganisation }) => {
  const {
    name,
    defaultCurrency,
    adsManagerAccount,
    usesGlobalTags,
  } = organisation;
  const handleCheckboxChange = (event, { checked }) => {
    onChange(event, { name: 'usesGlobalTags', value: checked });
  };
  return (
    <Card fluid>
      <Card.Content header="Organisation Settings" />
      <Card.Content>
        <Form>
          <Grid columns={3}>
            <Grid.Row>
              <Grid.Column>
                <Form.Field
                  control={Select}
                  label="Default Currency (for campaign budgets etc)"
                  fluid
                  search
                  onChange={onChange}
                  value={defaultCurrency}
                  name="defaultCurrency"
                  options={DYZIO_CURRENCIES}
                />
                <Divider />
                <Checkbox
                  checked={usesGlobalTags}
                  label="Use global tags"
                  name="usesGlobalTags"
                  onChange={handleCheckboxChange}
                />
              </Grid.Column>
              <Grid.Column>
                <FacebookAdsManager
                  canLinkCampaigns={false}
                  name={name}
                  account={adsManagerAccount}
                />
              </Grid.Column>
              <Grid.Column>
                <ShopifyConnectionSettings organisation={organisation} fetchOrganisation={fetchOrganisation} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </Card.Content>
    </Card>
  );
};

OrganisationSettings.propTypes = {
  organisation: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  fetchOrganisation: PropTypes.func.isRequired,
};

export default OrganisationSettings;



/** WEBPACK FOOTER **
 ** ./src/components/organisation-settings/index.js
 **/